import { render, staticRenderFns } from "./table-model.vue?vue&type=template&id=37519cd4&scoped=true"
import script from "./table-model.vue?vue&type=script&lang=js"
export * from "./table-model.vue?vue&type=script&lang=js"
import style0 from "./table-model.vue?vue&type=style&index=0&id=37519cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37519cd4",
  null
  
)

export default component.exports